import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { api } from "../api";
import {Game, Theme} from "../../types/games";
import {Language} from "../../translations";
import {setGameSession} from "./gameSession";

export type GameState = {
    loaded: boolean
    error: string | null
    gameStarted: boolean
    gameTheme?: Theme
    data?: Game
    language: Language
};

const initialState: GameState = {
    loaded: false,
    error: null,
    gameStarted: false,
    gameTheme: undefined,
    data: undefined,
    language: 'fi'
};

export const getGame = createAsyncThunk(
    'game/getGame',
    async (gameSlug:string | undefined, thunkAPI) => {
        try {
            const response = await api.get(`/API/games/slug/${gameSlug}`);
            if (response.session !== null) {
                thunkAPI.dispatch(setGameSession(response.session));
            }
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


const slice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        setFormData(state, action) {
            if (state.data) {
                state.data.form.forEach((field) => {
                    if (field.name in action.payload) {
                        field.value = action.payload[field.name];
                    }
                });
            }
        },
        startGame(state) {
            state.gameStarted = true;
        },
        updateGameTheme(state, action) {
            state.gameTheme = action.payload;
        }

    },
    extraReducers: (builder) => {
        builder.addCase(getGame.fulfilled, (state, action) => {
            state.loaded = true;
            state.error = null;
            state.data = action.payload;
            state.gameTheme = action.payload.theme;
            state.language = action.payload.language;
            if (action.payload.session) {
                state.gameStarted = true;
            }
        });
        builder.addCase(getGame.rejected, (state, action) => {
            state.loaded = true;
            if (typeof action.payload === 'string') {
                state.error = action.payload as string;
            } else if (typeof action.error?.message === 'string') {
                state.error = action.error.message;
            }
        });
    }
});

export const { startGame, updateGameTheme, setFormData } = slice.actions;
export default slice.reducer;